import cn from "classnames";
import styles from "./Hero.module.scss";
import logo from '../../resources/icons/white.svg';
import title from '../../resources/title.png';

export const Hero = ({handler}) => {
    return (
        <div className={styles.hero}>
            <div className={styles.wrapper}>
                <img className={styles.logo} src={logo} alt="2x2"/>
                <img src={title} alt="Колдуй Отсюда" className={styles.title}/>
                <div className={styles.text}>Как гласят легенды, декабрь — отличное время для прогнозов. Получи предсказание от героев нового сериала 2х2</div>
                <button className={cn("button", styles.button)} onClick={handler}>наколдовать</button>
            </div>
            <div className={cn(styles.bg, styles.bg_top)}/>
            <div className={cn(styles.bg, styles.bg_left_1)}/>
            <div className={cn(styles.bg, styles.bg_left_2)}/>
            <div className={cn(styles.bg, styles.bg_left_3)}/>
            <div className={cn(styles.bg, styles.bg_left_4)}/>
            <div className={cn(styles.bg, styles.bg_right_1)}/>
            <div className={cn(styles.bg, styles.bg_right_2)}/>
            <div className={cn(styles.bg, styles.bg_right_3)}/>
        </div>
    )
}